var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.3 8.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#c192f3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.15,
    cy: 4.15,
    r: 4.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.96,3.14v3.01c0,.1-.08,.18-.18,.18h-.9c-.1,0-.18-.08-.18-.18V3.14c0-.1,.08-.18,.18-.18h.9c.1,0,.18,.08,.18,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.92,1.36V6.15c0,.1-.08,.18-.18,.18h-.97c-.1,0-.18-.08-.18-.18V1.36c0-.1,.08-.18,.18-.18h.97c.1,0,.18,.08,.18,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.84,4.36v1.79c0,.1-.08,.18-.17,.18h-.94c-.1,0-.18-.08-.18-.18v-1.79c0-.1,.08-.18,.18-.18h.93c.1,0,.18,.08,.18,.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporteIcon);
export default __webpack_public_path__ + "static/media/reporte_icon.a39183d6ff331a475b7b0289aac0b9cd.svg";
export { ForwardRef as ReactComponent };